<template>
  <div class="info-region-container">
    <div class="all-content-container">
      <div class="container1">
        <div class="titlemaun" style="">
          <h4>设备告警配置</h4>
          <!-- <el-button v-allow="'060102'" type="primary" class="adduser" @click="addbox()">添加</el-button> -->
        </div>
        <div class="a69">
          <div>
            <el-button v-for="item in deviceList" :key="item.id" v-if="item.remark == '告警配置'" @click="changeDeviceId(item.id)" round :type="deviceId == item.id ? 'primary' : ''" class="adduser a12">{{ item.name }}</el-button>

            <!-- <el-button @click="changeDeviceId(27)" round :type="deviceId == 27 ? 'primary' : ''" class="adduser a12">三代种植柜</el-button>
            <el-button @click="changeDeviceId(36)" round :type="deviceId == 36 ? 'primary' : ''" class="adduser a12">恒温催芽柜</el-button>
            <el-button @click="changeDeviceId(47)" round :type="deviceId == 47 ? 'primary' : ''" class="adduser a12">菌菇柜</el-button>
            <el-button @click="changeDeviceId(52)" round :type="deviceId == 52 ? 'primary' : ''" class="adduser a12">蓝莓温室控制柜</el-button> -->
          </div>
          <!-- <el-button v-allow="'060102'" type="primary" class="adduser" @click="openVal()">添加告警配置模板</el-button> -->
        </div>
      </div>
      <div class="box_">
        <div></div>
        <div>
          <el-button v-allow="'060102'" type="primary" style="margin-left: 10px" class="adduser" @click="delModelAlarmSettings(27)">告警配置下发</el-button>
          <el-button v-allow="'060102'" type="primary" style="margin-left: 10px" class="adduser" @click="openTimeTask(27)">下发记录查询</el-button>
          <el-button type="primary" @click="openCmdTaskList">历史报文下发记录</el-button>
        </div>
      </div>
      <div>
        <!-- <el-button v-for="item in deviceList" :key="item.id" round type="primary" class="adduser a12">{{item.name}}</el-button> -->
      </div>
      <div class="info-content-container" v-loading="isLoading" :element-loading-text="'当前告警配置下发中，涉及的数据较多，时间较长，请勿点击其它操作'">
        <div class="table_content1" style="margin-top: 10px">
          <el-table :data="tableData" align="center" class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
            <el-table-column align="center" label="序号" width="95">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="alarmName" align="center" label="告警模板名称" width></el-table-column>
            <el-table-column prop="alarmLower" align="center" label="下限" width></el-table-column>
            <el-table-column prop="alarmUpper" align="center" label="上限" width></el-table-column>
            <el-table-column prop="unit" align="center" label="单位" width></el-table-column>
            <el-table-column align="center" label="状态" width>
              <template slot-scope="scope">
                <span v-if="scope.row.status == 0">已启用</span>
                <span v-if="scope.row.status == 1">已禁用</span>
              </template>
            </el-table-column>
            <el-table-column prop="updateTime" align="center" label="创建修改时间" width></el-table-column>

            <el-table-column fixed="right" align="center" label="操作" width>
              <template slot-scope="scope">
                <!-- <el-button @click="handleClick(scope.row.id,'edit')" type="text" size="small">编辑</el-button>@click="updatabox(scope.row.id)" -->
                <!-- <el-button v-allow="'060104'" type="text" size="small" @click="delModelAlarmSettings(scope.row.id)">下发</el-button> -->
                <!-- <el-button v-allow="'060103'"  type="text" size="small"></el-button> -->
                <span style="margin-right: 20px" @click="updatabox(scope.row.id)" class="dit">编辑</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <div class="pagination-container">
          <div class="page"></div>
          <div class="pagination-content-container">
            <el-pagination background layout="prev, pager, next,jumper" class="pageTap" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" :total="total"></el-pagination>
          </div>
        </div> -->
        <el-dialog :title="title" :visible.sync="dialogVisible" width="550px" :before-close="handleClose" center>
          <div class="equipmentcenter-opption-box">
            <el-form :rules="rules" :model="form" ref="form" label-width="100px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="上限值：">
                    <el-input-number placeholder="请输入下限值" v-model="form.alarmUpper" :precision="2" :step="1" :min="-99999999" :max="99999999" size="small" clearable style="width: 80%"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="推送方式：">
                    <el-select v-model="pushMode0" style="width: 80%" multiple @change="getId" clearable placeholder="请选择">
                      <el-option label="邮箱发送" value="0" />
                      <el-option label="短信发送" value="1" />
                      <el-option label="语音拨号提醒" value="4" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="下限值：">
                    <el-input-number placeholder="请输入下限值" v-model="form.alarmLower" :precision="2" :step="1" :min="-99999999" :max="99999999" size="small" clearable style="width: 80%"></el-input-number>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="推送方式：">
                    <el-select v-model="pushMode1" style="width: 80%" multiple clearable placeholder="请选择">
                      <el-option label="邮箱发送" value="0" />
                      <el-option label="短信发送" value="1" />
                      <el-option label="语音拨号提醒" value="4" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="状态：">
                    <el-select v-model="form.status" style="width: 80%" clearable placeholder="请选择">
                      <el-option label="启用" :value="0" />
                      <el-option label="禁用" :value="1" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="info" @click="resetForm">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">确定</el-button>
          </span>
        </el-dialog>
        <el-dialog :title="ds_name" :visible.sync="timedTaskDialog_" :before-close="handleClose_1234" width="1100px" center style="z-index: 10000">
          <el-col :span="11">
            <div class="flex" style="margin: 10px">
              <div class="titii">操作时间：</div>
              <el-date-picker v-model="searchFormtimeTask.time" type="datetimerange" :picker-options="pickerOptions" @change="getTime_" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"> </el-date-picker>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex" style="margin: 10px">
              <div class="titii">操作内容：</div>
              <el-input v-model="searchFormtimeTask.alarmName" placeholder="请输入内容"></el-input>
            </div>
          </el-col>
          <el-col :span="4" style="margin: 7px">
            <el-button type="primary" class="status_open" @click="getGrowthModelDecisionHisDataSendList"> 查询 </el-button>
            <el-button class="status_open" @click="reast"> 重置 </el-button>
          </el-col>
          <div class="table_content1" style="margin-top: 10px">
            <el-table :data="timeTsktableData" align="center" class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
              <el-table-column prop="alarmName" align="center" label="告警名称" width></el-table-column>
              <el-table-column prop="alarmLower" align="center" label="下限" width></el-table-column>
              <el-table-column prop="alarmUpper" align="center" label="上限" width></el-table-column>
              <el-table-column prop="unit" align="center" label="单位" width></el-table-column>
              <el-table-column align="center" label="状态" width>
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 0">已启用</span>
                  <span v-if="scope.row.status == 1">已禁用</span>
                </template>
              </el-table-column>
              <el-table-column prop="username" align="center" label="下发人" width></el-table-column>

              <el-table-column prop="updateTime" align="center" label="创建修改时间" width="180px"></el-table-column>
            </el-table>
          </div>
          <div class="pagination-container">
            <div class="page"></div>
            <div class="pagination-content-container">
              <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange_" :current-page="searchFormtimeTask.pageNum" :page-size="searchFormtimeTask.pageSize" :total="total_"></el-pagination>
            </div>
          </div>
          <div slot="footer" class="dialog-footer flex1">
            <div></div>
            <div>
              <el-button type="primary" @click="handleClose_1234">确 定</el-button>
            </div>
          </div>
        </el-dialog>
        <el-dialog title="添加告警配置模板" :visible.sync="dialogVisible_0" width="500px" :before-close="handleClose1" center>
          <div class="equipmentcenter-opption-box">
            <el-form :rules="rules" :model="form" ref="form" label-width="100px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="设备：">
                    <el-select v-model="wId" clearable placeholder="请选择">
                      <el-option v-for="item in deviceList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button type="info" @click="handleClose1">取消</el-button>
            <el-button type="primary" @click="submitForm_0('form')">确定</el-button>
          </span>
        </el-dialog>
        <Info ref="info"></Info>
      </div>
    </div>
  </div>
</template>
<script>
import Info from '../timedTask/components/info.vue'
import store from '@/store/index'
export default {
  components: {
    Info
  },
  name: 'approvalTemplate',
  data() {
    return {
      wId: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近五天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 5)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      deviceId: '',
      timedTaskDialog_: false,
      searchFormtimeTask: {
        deviceId: '',
        pageNum: 1,
        pageSize: 10,
        startTime: '',
        endTime: '',
        time: '',
        alarmName: ''
      },
      total_: 1,

      pushModeoptions: [
        {
          value: '0',
          label: '邮箱发送'
        },
        {
          value: '1',
          label: '短信发送'
        },
        {
          value: '2',
          label: 'APP推送'
        },
        {
          value: '3',
          label: '小程序推送'
        },
        {
          value: '4',
          label: '语音拨号提醒'
        }
      ],
      value: '',
      name: '',
      allSysUserList: [], //查询所有用户
      editId: '', //详情id（查询详情时使用））
      id: '',
      list: [], //审批模板详情表(对象)
      remark: '', //备注
      title: '', //标题
      updateId: '', //创建修改人员id
      updateTime: '', //创建修改时间
      dialogTitle: '',
      pagesize: 10,
      currentPage: 1,
      total: 0,
      loading: false, //加载
      dialogVisible: false, //添加弹框
      dialogVisible_0: false,

      formInline: {
        //查询条件（参数）
        name: ''
      },
      form: {
        alarmLower: '',
        alarmUpper: '',
        status: '',
        id: ''
      },
      pushMode0: '',
      pushMode1: '',
      pushMode0Id: '',
      pushMode1Id: '',
      tabPosition: 'left',
      activeName2: 'pane1',
      dialogformInline: {
        //添加参数或者编辑参数
        title: '',
        role: '', // 角色
        nink: '', // 昵称
        organization: '', // 组织机构
        password: '', //密码
        userName: '', //姓名
        gender: '', //性别
        ipone: '', //手机号
        eamil: '', //邮箱
        qq: ''
      },
      dialogRules: {
        // 弹框表单验证
        titles: [{ required: true, message: '请输入审批标题', trigger: 'change' }]
      },
      tableData: [],
      noneList: [],
      editId: '',
      colorType: '#409EFF',
      isLoading: false,
      userName: '',
      userType: '',
      tableData: [],
      title: '',
      type: '',
      dateRange: ['', ''],
      timeTsktableData: [],
      deviceList: [],
      dialogVisible: false,
      title: '添加告警模板配置',
      isupdate: false,
      id: '',
      keyword: '',
      name: '',
      rules: {
        alarmLower: [
          {
            required: true,
            message: '请输入下限',
            trigger: 'change'
          }
        ],
        alarmUpper: [
          {
            required: true,
            message: '请输入上限',
            trigger: 'change'
          }
        ],
        status: [
          {
            required: true,
            message: '请选择状态',
            trigger: 'change'
          }
        ]
      }
    }
  },

  computed: {},
  created() {
    this.init()
    this.getNumericalByUser()
  },
  mounted() {},
  methods: {
    openCmdTaskList() {
      // this.$refs.info.searchFormTimingTaskRecording.decisionId = this.value
      this.$refs.info.searchFormTimingTaskRecording.taskType = 4
      this.$refs.info.openTimeTask_1()
    },
    changeDeviceId(val) {
      this.deviceId = val
      console.log(this.deviceId, 889)

      this.getModelAlarmSettingsList()
    },
    getId(val) {
      console.log(val)
    },
    openVal() {
      this.dialogVisible_0 = true
    },
    handleClose_1234() {
      this.timedTaskDialog_ = false
      this.searchFormtimeTask = {
        pageNum: 1,
        pageSize: 10,
        total: 1,
        startTime: '',
        endTime: '',
        time: '',
        alarmName: '',
        deviceId: ''
      }
    },
    reast() {
      this.searchFormtimeTask = {
        pageNum: 1,
        pageSize: 10,
        total: 1,
        startTime: '',
        endTime: '',
        time: '',
        alarmName: '',
        deviceId: this.searchFormtimeTask.deviceId
      }
      this.getGrowthModelDecisionHisDataSendList()
    },
    openTimeTask(val, item) {
      this.timedTaskDialog_ = true
      this.searchFormtimeTask.deviceId = this.deviceId
      this.ds_name = `下发记录`
      this.getGrowthModelDecisionHisDataSendList()
    },
    handleCurrentChange_(currentPage) {
      this.searchFormtimeTask.pageNum = currentPage
      this.getGrowthModelDecisionHisDataSendList()
    },
    getTime_(val) {
      this.searchFormtimeTask.startTime = val[0]
      this.searchFormtimeTask.endTime = val[1]
      this.getGrowthModelDecisionHisDataSendList()
    },
    getGrowthModelDecisionHisDataSendList() {
      this.$api.system.getGrowthModelSetAlarmHisDataList(this.searchFormtimeTask).then(res => {
        if (res.code == 200) {
          this.timeTsktableData = res.data
          this.total_ = res.count
        }
      })
    },
    //清空
    empty() {
      this.form = {
        alarmLower: '',
        alarmUpper: '',
        status: '',
        id: ''
      }
      this.pushMode0 = ''
      this.pushMode1 = ''
    },
    resetForm(formName) {
      this.dialogVisible = false

      this.form = {
        alarmLower: '',
        alarmUpper: '',
        status: '',
        id: ''
      }
      this.pushMode0 = ''
      this.pushMode1 = ''
    },
    addbox() {
      this.empty()
      this.title = '添加告警模板配置'
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs['form'].resetFields()
      this.resetForm()
      this.dialogVisible = false
    },
    handleClose1() {
      this.dialogVisible_0 = false
      this.wId = ''
    },
    //弹框里的数据
    delnode(index) {
      this.noneList.splice(index, 1)
    },
    init() {
      this.getModelAlarmSettingsList() //列表信息
    },
    handleCurrentChange() {
      //下一页
      this.currentPage = 1
      this.getModelAlarmSettingsList() //查询列表
    },
    // 查询
    onSubmit() {
      this.getModelAlarmSettingsList() //查询列表
    },
    // 重置
    resetBth() {
      this.formInline.name = ''
      this.onSubmit()
    },
    getNumericalByUser() {
      this.$api.system.getNumericalByUser({ id: sessionStorage.getItem('USER_ID') }).then(res => {
        if (res.code == 200) {
          this.deviceList = res.data
          for (let i = 0; i < this.deviceList.length; i++) {
            if (this.deviceList[i].remark == '告警配置') {
              this.changeDeviceId(this.deviceList[i].id)
              break
            }
          }
          // this.deviceList.map(item => {
          //   if (item.remark == '告警配置') {
          //   }
          // })
        }
      })
    },

    //查询告警模板列表
    getModelAlarmSettingsList() {
      this.loading = true //加载
      this.$api.system
        .getGrowthModelSetAlarms({ id: this.deviceId })
        .then(res => {
          if (res.code == 200) {
            this.loading = false //关闭加载
            this.total = res.count //
            this.tableData = res.data
          } else {
            this.loading = false //关闭加载
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    //删除审批模板
    delModelAlarmSettings(id) {
      this.$confirm('是否下发？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.isLoading = true

          this.$api.system.sendTask({ id: this.deviceId }).then(res => {
            if (res.code == 200) {
              this.getModelAlarmSettingsList() //列表刷新
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.isLoading = false
            } else {
              this.$message.error(res.msg)
              this.isLoading = false
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    addbar() {
      //添加（新增保存审批模板）
      this.empty()
      this.editId = ''
      this.dialogTitle = '添加告警模板配置'
      this.noneList = [] //清空编辑时的数据
      this.dialogVisible = true
      this.getAllSysUser() //查询所有用户
      this.empty()
    },
    handleClick(id, type) {
      if (type == 'edit') {
        this.editId = id
        this.dialogTitle = '编辑告警模板配置'
        this.dialogVisible = true
        this.getapproveTemplateEdit(id) //查询审批模板详情
        this.getAllSysUser() //查询所有用户
      }
    },
    // 添加用户弹框确定
    centerDialogVisibles() {
      this.dialogVisible = false
      // 根据dialogTitle来判断是新增还是编辑
      if (dialogTitle == '添加告警模板') {
        //新增用户
      }
    },
    empty() {
      this.dialogformInline.title = ''
    },
    submitForm_0() {
      this.$api.system.saveGrowthModelSetAlarmModel({ id: this.wId }).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.dialogVisible_0 = false
          this.wId = ''
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.form.alarmUpper > this.form.alarmLower) {
            this.save()
            this.save1(this.pushMode0Id, this.pushMode0)
            this.save1(this.pushMode1Id, this.pushMode1)
          } else {
            this.$message({
              type: 'warning',
              message: '请输入正确的上下限'
            })
          }
        } else {
          return false
        }
      })
    },
    cancellation() {
      //弹框取消时
      this.empty()
      this.$forceUpdate()
      this.dialogVisible = false
    },
    save1(id, model) {
      var dto = {
        id: id,
        pushMode: model.join(',')
      }
      this.$api.system.updateAlarmPush(dto).then(res => {})
    },
    //添加保存审批模板(新增)
    addSaveApproveTemplate(list, id, title) {
      this.loading = true //开启加载
      this.$api.system
        .addSaveApproveTemplate(
          id, //编辑id
          list, //审批模板详情表(对象)
          this.remark, //备注
          title, //标题
          this.updateId, //创建修改人员id
          this.updateTime //创建修改时间
        )
        .then(res => {
          if (res.code == 200) {
            this.empty()
            this.dialogVisible = false
            this.loading = false //关闭加载
            this.geTapproveTemplate() //刷新列表
            this.$message({ type: 'success', message: res.msg })
          } else {
            this.dialogVisible = false
            this.loading = false //关闭加载
            this.$message.error(res.msg)
          }
        })
    },
    //编辑列表数据接口
    setApproveTemplate() {
      this.loading = true //开启加载
      this.$api.system.setUserMessageList().then(res => {
        if (res.code == 200) {
          this.loading = false //关闭加载
          this.$meessage({ type: 'success', message: res.msg })
        } else {
          this.loading = false //关闭加载
          this.$meessage.error(res.msg)
        }
      })
    },
    //编辑时获取数据  查询审批模板详情
    getapproveTemplateEdit(id) {
      this.loading = true //开启加载
      this.$api.system
        .getapproveTemplateEdit(
          this.currentPage, //第几页，默认1
          this.pagesize, //默认展示多少条，默认10
          id, //详情id（查询详情时使用））
          this.formInline.title //标题
        )
        .then(res => {
          if (res.code == 200) {
            this.loading = false //关闭加载
            this.dialogformInline.title = res.data.title // 标题
            //对环节进行梳理
            this.noneList = res.data.approveUserNames.split('——')
            var arr = []
            for (var i = 0; i < this.noneList.length; i++) {
              if (this.noneList[i] != 'null') {
                arr.push(this.noneList[i])
              }
            }
            console.log(arr)
            this.noneList = arr
          } else {
            this.loading = false //关闭加载
            this.$meessage.error(res.msg)
          }
        })
    },
    //查询所有用户
    getAllSysUser() {
      this.$api.system.getAllSysUser().then(res => {
        if (res.code == 200) {
          this.allSysUserList = res.data //所有用户
        } else {
          this.$meessage.error(res.msg)
        }
      })
    },
    //新增环节
    add: function () {
      let cope = {
        modelAlarmSettingsId: '',
        id: '',
        pushMode: [],
        name: '',
        startValue: undefined,
        endValue: undefined,
        colorType: ''
      }
      this.form.alarmDetails.push(cope)
    },

    permissionfun(str) {
      //判断权限
      return this.permission.indexOf(str) > -1
    },
    filteremojifun(e, name, ruleForm) {
      this.$utils.filteremojifun(this, e, name, ruleForm)
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage
      this.getModelAlarmSettingsList()
    },

    save() {
      var dto = this.form

      this.$api.system.saveGrowthModelSetAlarm(dto).then(res => {
        if (res.code == 200) {
          this.$toaster.ok('保存成功')
          this.dialogVisible = false
          this.init()
          this.form.id = ''
        } else {
        }
      })
    },
    // addbox(){
    // 	this.form.updatestate = 1
    //   this.title = "新增告警模板"
    //   this.dialogVisible = true
    // },
    updatabox(id) {
      this.title = '编辑告警模板'
      this.getAlarmSettings(id)
      this.getAlarmPush(id)
      this.dialogVisible = true
    },
    del2(id) {
      var idd = parseInt(id)
      this.$confirm('是否确定删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$api.device.delfun('model/alarmSettings/deleteDeviceDevice', idd).then(res => {
          if (res.code == 200) {
            this.getIotDeviceWarnSet()
            this.$toaster.ok(res.msg)
          } else {
            this.$toaster.error(res.msg)
          }
        })
      })
    },
    getAlarmPush(id) {
      //根据ID详情
      this.$api.system
        .getAlarmPush({ id: id })
        .then(res => {
          if (res.code == 200) {
            console.log(this.form)
            this.pushMode0 = res.data[0].pushMode.split(',')
            this.pushMode0Id = res.data[0].id
            this.pushMode1 = res.data[1].pushMode.split(',')
            this.pushMode1Id = res.data[1].id
          } else {
            this.$toaster.error(res.msg)
          }
        })
        .catch(() => {})
    },
    getAlarmSettings(id) {
      //根据ID详情
      this.$api.system
        .getGrowthModelSetAlarm({ id: id })
        .then(res => {
          if (res.code == 200) {
            this.form = res.data
          } else {
            this.$toaster.error(res.msg)
          }
        })
        .catch(() => {})
    },
    del: function (index) {
      this.form.alarmDetails.splice(index, 1)
    }
  }
}
</script>
<style lang="scss">
.a12 {
  margin: 10px;
  line-height: 8px !important;
}
.box-padding {
  padding: 20px;
}

.box-bg {
  background: #fff;
}

.color-choice {
  width: 66px;
  height: 28px;
  background: #4087f0;
  border-radius: 4px;
  position: relative;
  top: 7px;
  border: 5px solid #eee;
}

.mudel-box {
  .big-div2 {
    width: 49%;
    float: left;
  }

  .mid-div {
    width: 24%;
    float: left;
    transform: translateX(-60px);
  }

  .mid-div3 {
    width: 3%;
    float: left;
  }
}
.box_ {
  display: flex;
  justify-content: space-between;
}
.flex {
  display: flex;
  align-items: center;
}
.titii {
  white-space: nowrap;
}

::deep .el-date-editor {
  .el-range-separator {
    width: 12% !important;
  }
}
.a13 {
  display: flex;
  flex-flow: column;
  justify-content: space-around;
}
.flex1 {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.dit {
  color: #4087f0;
  cursor: pointer;
}
.a69 {
  display: flex;
  justify-content: space-between;
}
</style>
